
import { deepcopy, makeFilterFunction } from "./utility.js";

export function queryTitleItem(titleItem, ai, specifier) {
  let flag = true;
  // filtering: index, text... (todo)
  if (flag) {
    if (specifier.index !== undefined && ai !== specifier.index) flag = false;
    if (specifier.id !== undefined && titleItem.name !== specifier.id) flag = false;
    if (specifier.text !== undefined) {
      if (specifier.text.constructor.name !== "Array") {
        specifier.text = [specifier.text]
      }
      specifier.text.forEach(textQuery => {
        if (textQuery.constructor.name === "String") {
          flag = (textQuery === titleItem.text)
        } else {
          flag = makeFilterFunction(textQuery, true)(titleItem?.text?.map(d => d.text).join(" "))
        }
      });
    }
  }
  return flag;
}

export async function TitleTransformation(role, spec, original, specifier, action, option) {
  if (action === "add" && specifier.index === undefined && specifier.text === undefined) {
    let indexTo;
    if (option.index !== undefined) indexTo = option.index;
    else indexTo = spec.title.items.length;
    // make annotation item
    // append it
  } else if (action === "remove") {
    if (spec.title?.items?.length > 0) {
      spec.title?.items?.forEach((titleItem, ai) => {
        let flag = queryTitleItem(titleItem, ai, specifier);
        if (flag) {
          titleItem.remove = true;
        }
      });
      spec.title.items = spec.title.items.filter(_ => !_.remove);
    }
  } else if (action === "modify" || action === "reposition") {
    spec.title?.items?.forEach((titleItem, ai) => {
      let flag = queryTitleItem(titleItem, ai, specifier);
      if (flag) {
        Object.keys(option).forEach(propertyKey => {
          let _propKey = { "textAlign": "align" }[propertyKey] || propertyKey;
          if (!["role", "items"].includes(propertyKey)) {
            if (option[propertyKey] === null) {
              delete titleItem[_propKey];
            } else {
              if (option[propertyKey] !== undefined) titleItem[_propKey] = option[propertyKey];
            }
          }
        });
      }
    });
  } else if (action === "replace") {
    let isSeparate = option?.separate || option?.separate === undefined
    if (!isSeparate) {
      spec.title?.items?.forEach((titleItem, ai) => {
        let flag = queryTitleItem(titleItem, ai, specifier);
        if (flag) {
          if (option?.to) {
            if (option.to.role === "annotation") {
              if (spec.annotation === undefined) spec.annotation = {};
              if (spec.annotation.items === undefined) spec.annotation.items = [];
              let pasteTo = deepcopy(titleItem)
              pasteTo.type = "text";
              Object.keys(titleItem).forEach(propertyKey => {
                if (["fontColor", "fontSize", "align", "width", "textAlign", "fontWeight"].includes(propertyKey)) {
                  let _propertyKey = { "textAlign": "align" }[propertyKey] || propertyKey;
                  if (pasteTo.text.constructor.name === "String") {
                    pasteTo.text = [{ "text": pasteTo.text }];
                  } else if (pasteTo.text.constructor.name === "Array" && pasteTo.text.every(d => d.constructor.name === "String")) {
                    pasteTo.text = pasteTo.text.map(d => { return { text: d } });
                  }
                  pasteTo.text = pasteTo.text.map(textElem => {
                    if (propertyKey === "width") {
                      if (pasteTo[_propertyKey] !== undefined) {
                        textElem.width = titleItem[propertyKey];
                      } else {
                        textElem.width = 150;
                      }
                    } else {
                      textElem[_propertyKey] = titleItem[propertyKey]
                    }
                    return textElem;
                  });
                  delete pasteTo[propertyKey];
                }
                else if (propertyKey !== "type") {
                  pasteTo[propertyKey] = titleItem[propertyKey];
                }
              })
              Object.keys(option.to).forEach(propertyKey => {
                if (!["role", "separate"].includes(propertyKey)) {
                  if (["fontColor", "fontSize", "align", "width", "textAlign", "fontWeight"].includes(propertyKey)) {
                    let _propertyKey = { "textAlign": "align" }[propertyKey] || propertyKey;
                    pasteTo.text = pasteTo.text.map(textElem => {
                      if (option.to[_propertyKey] !== null) {
                        textElem[_propertyKey] = option.to[propertyKey];
                      } else {
                        delete textElem[_propertyKey];
                      }
                      return textElem;
                    });
                  } else {
                    if (option.to[propertyKey] !== null) pasteTo[propertyKey] = option.to[propertyKey]
                    else delete pasteTo[propertyKey];
                  }
                }
              })
              spec.annotation.items.push(pasteTo);
              titleItem.remove = true;
            }
          }
        }
      });
    } else {
      let pasteTo = [];
      spec.title?.items?.forEach((titleItem, ai) => {
        let flag = queryTitleItem(titleItem, ai, specifier);
        if (flag) {
          pasteTo.push(deepcopy(titleItem));
          titleItem.remove = true;
        }
      });
      if (option?.to) {
        if (option.to.role === "annotation") {
          if (spec.annotation === undefined) spec.annotation = {};
          if (spec.annotation.items === undefined) spec.annotation.items = [];
          pasteTo.forEach(pitem => {
            if (spec.title.fill !== undefined) {
              pitem.fill = spec.title.fill;
            }
          })

          let annoItem = {
            "type": "text",
            "text": pasteTo,
            "width": 150
          }

          Object.keys(option.to).forEach(propertyKey => {
            if (propertyKey === "items" && option.to.items.constructor.name === "Object") {
              Object.keys(option.to.items).forEach(itemKey => {
                pasteTo.forEach(pitem => {
                  if (option.to[propertyKey][itemKey] !== null) pitem[itemKey] = option.to[propertyKey][itemKey];
                  else delete pitem[itemKey];
                });
              });
            }
            else if (!["role", "separate"].includes(propertyKey)) {
              if (option.to[propertyKey] !== null) pasteTo[propertyKey] = option.to[propertyKey];
              else delete pasteTo[propertyKey];
            }
          })

          if (annoItem.x === undefined && annoItem.y === undefined && annoItem.position === undefined) annoItem.autoPositioning = true;
          if (annoItem.dx === undefined) annoItem.dx = "-50%";
          if (annoItem.dy === undefined) annoItem.dy = "-50%";
          spec.annotation.items.push(annoItem)
        }
      }
    }
    spec.title.items = spec.title.items.filter(_ => !_.remove);
  } else if (action === "swap") {
    if (option?.from?.index !== undefined && option?.to?.index !== undefined) {
      if (spec.title?.items?.[option.from.index] && spec.title?.items?.[option.to.index]) {
        let copyFrom = deepcopy(spec.title.items[option.from.index]);
        let copyTo = deepcopy(spec.title.items[option.to.index]);
        spec.title.items[option.from.index] = copyTo;
        spec.title.items[option.to.index] = copyFrom;
      }
    }
  }

  // else {
  //   let toRemove = [];
  //   if (option?.separate || option?.separate === undefined) {
  //     spec.title.items.forEach((titleItem, ai) => {
  //       let flag = queryTitleItem(titleItem, ai, specifier);
  //       console.log(specifier, titleItem, ai, flag);
  //       if (flag) {
  //         if (action === "remove") {
  //           // todo
  //           toRemove.push(ai);
  //         } else if (action === "modify") {
  //           // todo
  //           Object.keys(option).forEach(propertyKey => {
  //             let _propKey = { "textAlign": "align" }[propertyKey] || propertyKey;
  //             if (!["role", "items"].includes(propertyKey)) {
  //               if (option[propertyKey] === null) {
  //                 delete titleItem[_propKey];
  //               } else {
  //                 if (option[propertyKey] !== undefined) titleItem[_propKey] = option[propertyKey];
  //               }
  //             }
  //             // else if (propertyKey === "items") {
  //             //   if (option.items?.constructor.name === "Object") {
  //             //     spec.title.items.forEach(titleItem => {
  //             //       if (option.items[propertyKey] !== null) titleItem[_propertyKey] = option[propertyKey];
  //             //       else delete titleItem[_propertyKey];
  //             //     });
  //             //   } else if (option.items?.constructor.name === "Array") {
  //             //     spec.title.items.forEach((titleItem, ti) => {
  //             //       if (option.items[ti][propertyKey] !== null) titleItem[_propertyKey] = option.items[ti][propertyKey];
  //             //       else delete titleItem[_propertyKey];
  //             //     });
  //             //   }
  //             // }
  //           })
  //         } else if (action === "replace") {
  //           // todo

  //         } else if (action === "reposition") {

  //         }
  //       }
  //     })
  //   } else {
  //     let pasteTo = spec.title.items?.filter((annoItem, ai) => {
  //       let flag = true;
  //       // filtering: index, text... (todo)
  //       if (flag) {
  //         if (specifier.index !== undefined && ai !== specifier.index) flag = false;
  //         if (specifier.text !== undefined) {
  //           if (specifier.text.items !== undefined) {
  //             specifier.text.map((titem, tii) => {
  //               if (!makeFilterFunction(titem)(annoItem.itemx[tii]?.text)) flag = false;
  //             })
  //           } else {
  //             if (!makeFilterFunction(specifier.text)(annoItem.items[0].text)) flag = false;
  //           }
  //         }
  //       }
  //       if (action === "replace" || action === "remove") {
  //         toRemove.push(ai);
  //       }
  //       return flag;
  //     });
  //     if (action === "modify") {
  //       // todo
  //       if (option !== undefined) {
  //         Object.keys(option).forEach(propKey => {
  //           if (["width"].includes(propKey)) {
  //             spec.title[propKey] = option[propKey];
  //           } else {
  //             let _propKey = propKey;
  //             if (option[propKey] === null) {
  //               spec.title.items.forEach(titleItem => {
  //                 delete titleItem[_propKey]
  //               })
  //             } else if (option[propKey].constructor.name === "Array") {
  //               spec.title.items.forEach((titleItem, tii) => {
  //                 if (option[propKey][tii] === null) delete titleItem[_propKey];
  //                 else if (!option[propKey][tii]) titleItem[_propKey] = option[propKey][tii];
  //               })
  //             } else {
  //               spec.title.items.forEach((titleItem, tii) => {
  //                 if (!option[propKey]) titleItem[_propKey] = option[propKey];
  //               });
  //             }
  //           }
  //         })
  //       }
  //     } else if (action === "replace") {
  //       // todo

  //     } else if (action === "reposition") {

  //     }
  //   }
  //   spec.title.items = spec.title.items.filter((aitem, ai) => !toRemove.includes(ai));
  // }
  return spec;
}